module.exports = __webpack_public_path__ + "img/t_shirt_mask.a4494553.png";